<template>
  <div class="mt-3 mb-3 d-flex black--text">
    <div class="d-flex justify-center align-start mr-5">
      <v-icon>{{ icon }}</v-icon>
    </div>
    <div v-if="!daybookItem && !files" class="daybook-entry__content">
      <label class="caption grey--text"> {{ label }}</label>
      <div style="white-space: pre-line">{{ value }}</div>
      <div>{{ value2 }}</div>
      <!-- Rakenteinen sisältö (esim. tuntikirjausryhmät) samaan ikoni + otsikko -asetteluun. -->
      <slot />
    </div>
    <div v-if="daybookItem">
      <label class="caption grey--text"> {{ label }}</label>
      <div v-for="(item, index) in value" :key="index">
        <v-icon>mdi mdi-circle-small</v-icon><span>{{ item.value }}</span
        ><file-viewer v-if="item.files" :file-list="item.files" class="ml-3"></file-viewer>
      </div>
    </div>
    <div v-if="files">
      <label class="caption grey--text"> {{ label }}</label>
      <file-viewer :file-list="files"></file-viewer>
    </div>
  </div>
</template>

<script>
import FileViewer from '@/components/FileViewer';
export default {
  name: 'DaybookEntry',
  components: { FileViewer },
  props: {
    label: String,
    value: [String, Array],
    value2: [String],
    icon: String,
    files: Array,
    daybookItem: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Venyy rivin levyiseksi, jotta slotin taulukko saa koko leveyden eikä vuoda yli. */
.daybook-entry__content {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
